import { action, computed, makeObservable, observable } from 'mobx';
import MainStore from '.';
import moment from 'moment';

const MAX_LOGS = 200;

export default class ReplayDebugStore {
    private mainStore: MainStore;
    isVisible = false;
    logs: Array<{ ts: number; msg: string }> = [];

    constructor(mainStore: MainStore) {
        makeObservable(this, {
            isVisible: observable,
            logs: observable.shallow,
            toggle: action.bound,
            clear: action.bound,
            log: action.bound,
            logAction: action.bound,
            stats: computed,
        });

        this.mainStore = mainStore;

        // Enable by default if flag present
        try {
            const flag = localStorage.getItem('sc_replay_debug');
            this.isVisible = flag === '1' || flag === 'true';
        } catch {}
    }

    toggle() {
        this.isVisible = !this.isVisible;
        try { localStorage.setItem('sc_replay_debug', this.isVisible ? '1' : '0'); } catch {}
    }

    clear() {
        this.logs = [];
    }

    log(message: string) {
        this.logs.push({ ts: Date.now(), msg: message });
        if (this.logs.length > MAX_LOGS) {
            this.logs.splice(0, this.logs.length - MAX_LOGS);
        }
    }

    logAction(action: string, data?: Record<string, unknown>) {
        const suffix = data ? ` ${JSON.stringify(data)}` : '';
        this.log(`[${action}]${suffix}`);
    }

    get stats() {
        const rc = this.mainStore.replayController;
        const state = rc.getState();
        const bounds = this.mainStore.chartAdapter.epochBounds;
        const elSize = (window as any).__eventLog?.size?.() ?? undefined;
        const recSize = this.mainStore.eventRecorder?.size ?? undefined;
        const fmt = (e?: number | null) => (e ? moment(e).format('YYYY-MM-DD HH:mm:ss') : '—');
        return {
            mode: state.mode,
            playing: state.isPlaying,
            speed: state.playbackSpeed,
            progress: `${state.progress.toFixed(1)}%`,
            current: fmt(state.currentEpoch ?? undefined),
            start: fmt(state.replayStartEpoch ?? undefined),
            end: fmt(state.replayEndEpoch ?? undefined),
            windowLeft: fmt(bounds.leftEpoch || undefined),
            windowRight: fmt(bounds.rightEpoch || undefined),
            eventLogSize: elSize,
            recorderSize: recSize,
        };
    }
}
